export * from './lib/shared-app-core.module';
export * from './lib/page-title.service';
export * from './lib/init-providers';
export * from './lib/safe-logger.service';
export * from './lib/validation-regex';
export * from './lib/ids';
export * from './lib/debounce-constants';
export { BACKBASE_APP_VERSION, BackbaseVersionConfig } from './lib/version-printer.factory';
export { MockInterceptor } from './lib/mock.interceptor';
export { FocusHandlerService } from './lib/focus-handler.service';
